import {Injectable} from '@angular/core';
import {LoaderState} from "../models/models";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loaderSubject = new Subject<LoaderState>();
  loaderState = this.loaderSubject.asObservable();

  public visible: boolean = false;
  public text: string = '';

  constructor() {
  }

  destroyLoader() {
    this.visible = false;
    this.text = '';
  }

  buildLoader() {
    this.visible = true;
  }

  getText(value: any) {
    this.text = value;
  }

  // these two function are used for LoaderInterceptorService
  show() {
    this.loaderSubject.next({show: true} as LoaderState);
  }

  hide() {
    this.loaderSubject.next({show: false} as LoaderState);
  }
}
